import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-evaluateStatic",
  "use": "icon-evaluateStatic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-evaluateStatic\"><path d=\"M840.874667 0c61.610667 0 112.014222 51.2 112.014222 113.777778v739.555555c0 62.577778-50.403556 113.777778-112.014222 113.777778H168.96C107.292444 967.111111 56.888889 915.911111 56.888889 853.333333V113.777778c0-62.577778 50.403556-113.777778 112.014222-113.777778H840.817778z m13.482666 309.475556a43.008 43.008 0 0 0-61.44 0L567.751111 530.318222 409.770667 375.466667a43.008 43.008 0 0 0-61.44 0L155.420444 564.792889a41.016889 41.016889 0 0 0 0 60.188444c17.521778 17.237333 43.804444 17.237333 64.284445 0L380.586667 467.228444l155.022222 154.908445a43.008 43.008 0 0 0 61.44 0l257.365333-252.416a41.016889 41.016889 0 0 0 0-60.245333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/evaluateStatic.svg
// module id = XJA7
// module chunks = 78